import { useTranslation } from 'react-i18next';
import { Scrollbar } from 'react-scrollbars-custom';
import BllinkUtils from '../../../components/common/utils/utils';
import AptCardInMonitoring from './AptCardInMonitoring';
import AptCardWithoutMonitoring from './AptCardWithoutMonitoring';

const FilterUtils = BllinkUtils.Filter;

const AptMonitoringList = ({ records, filter, inMonitoring, buildingID }) => {
    const { t } = useTranslation();

    const renderRecordsInMonitoring = (record, i) => {
        const apt = record.ApartmentNum;
        const name = record.tenantName;
        const phone = record.tenantPhone;
        const email = record.Email;
        const monitoring = record.monitoring;
        const showItem = FilterUtils.filterItems([apt, name, phone, email], filter);

        return (
            showItem && (<AptCardInMonitoring
                key={i}
                apt={apt}
                name={name}
                phone={phone}
                email={email}
                buildingID={buildingID}
                monitoring={monitoring}
            />)
        )
    };

    const renderRecordsWithoutMonitoring = (record, i) => {
        const apt = record.ApartmentNum;
        const name = record.tenantName;
        const phone = record.tenantPhone;
        const email = record.Email;
        const monitoring = record.monitoring;
        const showItem = FilterUtils.filterItems([apt, name, phone, email], filter);

        return (
            showItem && (<AptCardWithoutMonitoring
                key={i}
                apt={apt}
                name={name}
                phone={phone}
                email={email}
                buildingID={buildingID}
                monitoring={monitoring}
            />)
        )
    };

    return (
        <Scrollbar
            style={{ width: '100%', height: 'calc(100vh - 200px)' }}
            trackYProps={{
                renderer: props => {
                    const { elementRef, ...restProps } = props;
                    return <div {...restProps} ref={elementRef} className="scroll-track" />;
                }
            }}
            thumbYProps={{
                renderer: props => {
                    const { elementRef, ...restProps } = props;
                    return <div {...restProps} ref={elementRef} className="scroll-thumb" />;
                }
            }}
            rtl={false}
            noScrollX
        >
            <div>
                {inMonitoring && records.length !== 0 && records.map((record, i) => renderRecordsInMonitoring(record, i))}
                {!inMonitoring && records.length !== 0 && records.map((record, i) => renderRecordsWithoutMonitoring(record, i))}
                {records.length === 0 && <div className='no_records'>{t('expenses.bank_adjustments.no_records')}</div>}
            </div>
        </Scrollbar>
    );
};

export default AptMonitoringList;
